import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SnackBarService } from 'src/app/shared';
import { SharedCustomersService } from 'src/app/shared/services/customers/customers.service';
import { LocationService } from 'src/app/shared/services/location/location.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-create-contact-group',
  templateUrl: './create-contact-group.component.html',
  styleUrls: ['./create-contact-group.component.scss']
})
export class CreateContactGroupComponent implements OnInit {

  createContactGroupForm:FormGroup=new FormGroup({})
  filterForm:FormGroup
  // customerControl = new FormControl('', [Validators.required]);
  selectedContacts: any[] = new Array<any>();
  lastFilter: string = '';
  filteredContacts: Observable<any[]>;
  availableContacts: any[];
  selectedContactsIDs: number[] = [];
  countries:any[]
  contactGroupId:any
  isEditingMode:boolean=false
  contactGroupDetail:any;
  officesList:any;
  contactsList:any
  allContactsList: any;
  panelOpenState: boolean = true;
  contactsDisplayedColumns = ['checkbox', 'name', 'email']
  selectedContactsDisplayedColumns = ['checkbox', 'name', 'email']
  checkContact:boolean=false;
  @ViewChild('selectedTable') table: MatTable<any>;

  pageSizeOptions: number[] = [
    25,
    50,
    100,
    200,
    500
  ]
  pageSize: number = this.pageSizeOptions[0];
  pageIndex : number = 0;
  pageOffset: number = 0;

  constructor(
    private notificationService:NotificationService,
    private activatedRoute:ActivatedRoute,
    private locationService:LocationService,
    private sharedCustomersService:SharedCustomersService,
    private snackbarservice:SnackBarService,
    private router:Router
  ) { }

  ngOnInit() {
    this.initForm();
    this.setRouteParam();
  }

  initForm(){
    this.createContactGroupForm=new FormGroup({
      name:new FormControl('',Validators.required),
    })

  }

  setRouteParam(){
    this.activatedRoute.params.subscribe(params=>{
      this.contactGroupId=params.id ? params.id : ''
    })
    if(this.contactGroupId){
      this.isEditingMode=true
      this.notificationService.getNotificationContactGroupDetail(this.contactGroupId).subscribe(data=>{
        this.contactGroupDetail=data
        this.fillContactSelectList()
        this.setContactGroupData();
        this.getContactsList();
      })
    }
    else{
      this.getContactsList();
    }
  }

  // setGroupData(){
  //   if(this.isEditingMode){
  //     this.createGroupForm.controls.name.patchValue(this.groupDetail.name)
  //     let customers:any[]=[]
  //     this.groupDetail.members.forEach(element => {
  //       this.customersList.filter(customer=>{
  //         if(customer.id === element){
  //           customers.push(customer)
  //         }
  //       })
  //     });
  //     this.selectedCustomers=customers;
  //     this.customerControl.setValue(this.selectedCustomers);
  //   }
  // }

  setContactGroupData(){
    if(this.isEditingMode){
      this.createContactGroupForm.controls.name.patchValue(this.contactGroupDetail.name)
      this.getAllContacts()
    }
  }

  // createGroup(){
  //   let members=[]
  //   this.customerControl.value.forEach(element => {
  //     members.push(element.id)
  //   });
  //   let params={
  //     name: this.createGroupForm.get('name').value,
  //     members: members
  //   }
  //   if(this.isEditingMode){
  //     this.notificationService.updateNotificationGroup(this.groupId,params).subscribe(
  //       success=>{
  //       this.snackbarservice.showSnack('notification group updated successfuly.')
  //       this.router.navigate(['/notifications/groups'])
  //       },
  //       error=>{
  //         this.snackbarservice.showSnack(error.error.detail)
  //       }    
  //     )
  //   }
  //   else{
  //     this.notificationService.createNotificationGroup(params).subscribe(
  //       success=>{
  //       this.snackbarservice.showSnack('notification group created successfuly.')
  //       this.router.navigate(['/notifications/groups'])
  //       },
  //       error=>{
  //         this.snackbarservice.showSnack(error.error.detail)
  //       }    
  //     )
  //   }
  // }


  createContactGroup(){
    let contacts:any[]=[]
    this.selectedContacts.forEach(element => {
      contacts.push(element.id)
    });
    let params={
      name: this.createContactGroupForm.get('name').value,
      contacts: contacts
    }
    if(this.isEditingMode){
      this.notificationService.updateNotificationContactGroup(this.contactGroupId,params).subscribe(
        success=>{
        this.snackbarservice.showSnack('notification contact group updated successfuly.')
        this.router.navigate(['/notifications/contacts-groups'])
        },
        error=>{
          this.snackbarservice.showSnack(error.detail)
        }    
      )
    }
    else{
      this.notificationService.createNotificationContactGroup(params).subscribe(
        success=>{
        this.snackbarservice.showSnack('notification contact group created successfuly.')
        this.router.navigate(['/notifications/contacts-groups'])
        },
        error=>{
          this.snackbarservice.showSnack(error.detail)
        }    
      )
    }
  }

  onSubmitFilterForm(){ 
    this.getContactsList(true);
  }

  onPaginateChange($event) {
    this.pageIndex = $event.pageIndex;
    this.pageSize = $event.pageSize;
    this.pageOffset = this.pageIndex * this.pageSize;
    this.getContactsList();
  }

  getContactsList(reset:boolean = false) {
    if(reset) {
      this.pageOffset = 0
    }
    let filters = { limit: this.pageSize, offset: this.pageOffset , ordering:'-id'};
    this.notificationService.getNotificationContactsList(filters).subscribe(
      success => {
        this.contactsList=success;
      }
    )
  }

  getAllContacts() {
    let filters = { limit: 10000, offset: 0 , ordering:'-id'};
    this.notificationService.getNotificationContactsList(filters).subscribe(
      success => {
        this.allContactsList=success.results;
        this.fillContactSelectList();
      }
    )
  }

  fillContactSelectList() {
    if(this.allContactsList && this.contactGroupDetail) {
      if(this.isEditingMode){
        for(let member of this.contactGroupDetail.contacts_detail) {
          // let c = this.allContactsList.find(contact=> contact.id === member.id)
          let c = member
          if(c) {
            this.selectedContacts.push(c)
            this.selectedContactsIDs.push(c.id)
          }
        };
        this.table.renderRows()
      }
    }
  }
  filter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.availableContacts.filter(option => {
        return option.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0
      })
    } else {
      return this.availableContacts.slice();
    }
  }

  displayFn(value: any[] | string): string | undefined {
    let displayValue: string;
    if (Array.isArray(value)) {
      value.forEach((contact, index) => {
        if (index === 0) {
          displayValue = contact.name;
        } else {
          displayValue += ', ' + contact.name;
        }
      });
    } else {
      displayValue = value;
    }
    return displayValue;
  }

  optionClicked(event: Event, contact: any) {
    event.stopPropagation();
    this.toggleSelection(contact);
  }

  toggleSelection(id) {
    let i = this.selectedContacts.indexOf(id)
    if(i != -1) {
      this.selectedContacts.splice(i, 1);
    } else {
      this.selectedContacts.push(id)
    }
  }

  isContactSelected(id) {
    return this.selectedContacts.indexOf(id) != -1
  }


  addContact(contact) {
    if(this.selectedContacts.indexOf(contact) == -1) {
      this.selectedContacts.push(contact);
      this.selectedContactsIDs.push(contact.id);
      this.table.renderRows()
    }
  }

  removeContact(index) {
    this.selectedContacts.splice(index, 1);
    this.selectedContactsIDs.splice(index, 1);
    this.table.renderRows();
  }

}
